import React, { useState } from 'react';
import '../../BarManagementSection/KeyModulesSection/KeyModules.css';

function SpecialKeyModules() {
  const [boxes, setBoxes] = useState([
    { id: 1, color: 'orange', zIndex: 3, bottom: '0%', width: '90%', height: '70%', courseHeader: 'Personality Development', courseDetails: 'The Personality Development module focuses on building self-confidence, grooming, professional etiquette, positive body language, and emotional intelligence to help students develop a strong and impactful personal presence.' },
    { id: 2, color: 'green', zIndex: 2, bottom: '5%', width: '80%', height: '70%', courseHeader:'Communication Skills', courseDetails: 'In the Communication Skills module, students are trained in verbal and non-verbal communication, active listening, public speaking, group discussions, and business correspondence to enhance their ability to communicate effectively in diverse hospitality settings.' },
    { id: 3, color: 'blue', zIndex: 1, bottom: '10%', width: '70%', height: '70%', courseHeader: 'Customer Service', courseDetails: 'The Customer Service module emphasizes the principles of guest satisfaction, complaint handling, service excellence, empathy, and proactive problem-solving, ensuring students are equipped to deliver outstanding guest experiences. ' },
    { id: 4, color: 'violet', zIndex: -1, bottom: '15%', width: '60%', height: '70%', courseHeader: 'World Class Training Facility From USA and Australia', courseDetails: 'The World-Class Training module, inspired by industry standards from the USA and Australia, introduces students to global hospitality practices, international service protocols,and quality assurance systems that prepare them for employment in top-tier hotels around the world.' },
  ]);

  const handleBoxClick = (id) => {
    const clickedBox = boxes.find(box => box.id === id);
    const remainingBoxes = boxes.filter(box => box.id !== id);

    // Move the clicked box to the front and adjust the remaining boxes
    setBoxes([
      { ...clickedBox, zIndex: 3, bottom: '0%', width: '90%' },
      ...remainingBoxes.map((box, index) => ({
        ...box,
        zIndex: 2 - index,
        bottom: `${5 + index * 5}%`,
        width: `${80 - index * 10}%`,
      })),
    ]);
  };

  return (
    <div className='keymodules-outer'>
      <div className="keymodules-inner">
        <div className="keymodules-left d-flex flex-column justify-content-start align-items-start">
          <h4 className="secondary-header">KEY MODULES</h4>
          <p className="letter-text">At LIMS we cover all the modules there are in the special courses. Starting from personality development to customer service - we offer you everything. <br /> By the end of your diploma course at, you will learn soft skills, communication skills, and all other advanced skill that will be required in this industry.</p>
        </div>
        <div className="keymodules-right">
          {boxes.map(box => (
            <div
              key={box.id}
              className="keymodules-box"
              style={{
                backgroundColor: box.color,
                zIndex: box.zIndex,
                bottom: box.bottom,
                width: box.width,
                height: box.height
              }}
              onClick={() => handleBoxClick(box.id)}
            >
              <div className="coursediv w-100 h-100 d-flex justify-content-center align-items-center flex-column" >
                <p className='paragraph-text d-flex justify-content-center align-items-center w-100 h-auto'>{box.courseHeader}</p>
                <p className='p-4 letter-text text-center d-flex justify-content-center align-items-center w-75 h-auto'>{box.courseDetails}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default SpecialKeyModules;
